import script from "./PaneTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PaneTabBar.vue?vue&type=script&setup=true&lang=js"

import "./PaneTabBar.vue?vue&type=style&index=0&id=5b5ae960&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b5ae960"]])

export default __exports__